<template>
<zm-dialog :visible.sync="visible" class="comparison-dialog" show-close @close="handleCancel">
  <h1 class="comparison-dialog__title" slot="title">{{ $t('marketing.new_pricing.full_plan') }}</h1>
  <FullComparisonTable :treeData="treeData" :colConfig="colConfig" :value="this.currentBasicPlusCategory" />
</zm-dialog>
</template>
<script>

import { ZoomMeetingComparisonDataMixins } from '@/components/full-comparison-table/comparison-data-mixins';
import FullComparisonTable from '@/components/full-comparison-table/full-comparison-table.vue';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { mapGetters } from 'vuex';
import { planTypes } from '@/common/constants';
import { get } from 'lodash';

export default {
  components: {
    FullComparisonTable,
  },
  mixins: [ZoomMeetingComparisonDataMixins, ConfirmComponent],
  computed: {
    ...mapGetters(['getSelectedPlans']),
    currentBasicPlusPlan() {
      return this.getSelectedPlans.find(item => item.type === planTypes.ZONE_BASIC_PLUS);
    },
    currentBasicPlusCategory() {
      return get(this.currentBasicPlusPlan || {}, 'category', 'zobasicp');
    },
    colConfig() {
      return [
        {
          title: this.$t('one.lite'),
          key: this.currentBasicPlusCategory,
          category: this.currentBasicPlusCategory,
          btn: null,
        },
        {
          title: this.$t('common.pro'),
          key: 'pro',
          category: 'pro',
          btn: null,
        },
      ];
    },
  }
}
</script>
<style lang="scss">
.comparison-dialog {
  .zm-dialog {
    max-width: 1000px;
    width: auto;
  }
  &__title {
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 150%;
    color: #00053D;
    text-align: center;
  }
}
</style>
